export default __webpack_public_path__ + "static/media/kickball-icon.29a076e0.svg";